import React, { useEffect, useState } from 'react'
import withRouter from '../utils/withRouter';
import Layout from './../layouts/Main';
import MOQ from './../components/MOQ'
import ContentLoader from "react-content-loader";
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { searchMoqByTerm } from './../store/actions/MoqActions';

const BlockLoader = ({
  height = 300,
  width = "100%",
  radius = 8,
  uniqueKey = "unique",
}) => (
  <ContentLoader
    uniqueKey={uniqueKey}
    speed={2}
    width={width}
    height={height}
    backgroundColor="#ECEBEB"
    foregroundColor="#b0b0b0"
  >
    <rect
      x="0"
      y="0"
      rx={`${radius}`}
      ry={`${radius}`}
      width="100%"
      height={`${height}`}
    />
  </ContentLoader>
);

function Search(props) {

    const { moqs: { search_moqs } } = props

    const [loading, setLoading] = useState(false);

    const [term, setTerm] = useState('')

    const [searchParams] = useSearchParams();

    useEffect(() => {

        let queryString = searchParams.get('q')

        if (queryString) {
            
            setTerm(queryString)

            fetchTerm(queryString)
        
        }

        async function fetchTerm (value) {
            setLoading(true)
            try {

                await props?.searchMoqByTerm(value)

            } catch (error) {

                if (error?.response?.data && error?.response?.data?.message) {

                    toast.error(`${error?.response?.data?.message}`, { autoClose: 10000 })

                }
            } finally {
                setLoading(false)
            }

        }

    }, [])

    return (

        <Layout>

            <h1 className="text-tangerine font-bold capitalize mt-2">Search Results for {term}</h1>

            <div className="grid grid-cols-2 md:grid-cols-6 gap-2 py-5">
                
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {loading && (
                    <BlockLoader uniqueKey="key1" height={250} radius={6} />
                )}
    
                {!loading && search_moqs && search_moqs.map((moq, i) => <MOQ key={i} moq={moq} />)}

            </div>

        </Layout>

    )

};

const mapStateToProps = (state) => {

    return {

        moqs: state.moqs,

    }

};

const mapDispatchToProps = (dispatch)  => { 

    return bindActionCreators({ searchMoqByTerm }, dispatch);

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search));
